import LogoMonogram from '../src/LogoMonogram';
export default LogoMonogram;
